import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function PHGeneralQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Mga Pangkalahatang Tanong" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  Ano ang Libreng Laruin na bersyon ng PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    Ang Libreng Laruin na bersyon ay nagbibigay-daan sa iyo na mag-enjoy ng lahat ng excitement ng poker nang hindi gumagamit ng tunay na pera. Naglalaro ka gamit ang libreng chips, kumikita ng Reward Points sa pamamagitan ng paglalaro, at ini-redeem ang mga ito sa Baazi Store para sa mga alok at gift cards mula sa mga nangungunang brand.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Maaari ko bang gamitin ang aking kasalukuyang account sa PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    Oo! Maaari kang mag-log in gamit ang iyong kasalukuyang account sa PokerBaazi. Kung bago ka, mag-sign up nang libre sa Google Play Store o Apple App Store - hindi kailangan ng deposito.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Maaari bang lumipat sa pagitan ng Libreng Laruin at Cash na mga mode?
                </div>
                <div className={style.sub_text3}>
                    Hindi. Ang PokerBaazi ngayon ay nakatuon nang buo sa Libreng Laruin - isang karanasan na paunang-kasanayan at batay sa mga gantimpala kung saan bawat kamay ay nakakatulong sa iyong pag-unlad.
                </div>
            </div>
        </div>
    )
}


export function PHLeaderboardAndProgression() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Mga Leaderboard at Pag-unlad" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  Paano gumagana ang mga leaderboard?
                </div>
                <div className={style.sub_text3}>
                    Sinusubaybayan ng mga leaderboard ang iyong pagganap sa mga mabilis na laro at torneo. Maglaro nang regular upang kumita ng mga puntos, umakyat ng mga ranggo, at manalo ng bonus na Reward Points bawat linggo.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Hindi nag-a-update ang aking ranggo sa leaderboard.
                </div>
                <div className={style.sub_text3}>
                    Nagre-refresh ang mga ranggo bawat ilang minuto. Kung hindi mo nakita ang update, ibahagi ang iyong username sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> at susuriin namin ito para sa iyo.
                </div>

            </div>
        </div>
    )
}

export function PHGameplayQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Mga Tanong sa Gameplay" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  Anong mga laro ang maaari kong laruin?
                </div>
                <div className={style.sub_text3}>
                    Maaari kang maglaro ng Texas Hold'em, Omaha, All-in or Fold, Super Hold'em, at Open Face Poker (OFC) - available sa mga mabilis na laro at torneo.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Wala na akong chips. Ano ang dapat kong gawin?
                </div>
                <div className={style.sub_text3}>
                    Makakatanggap ka ng libreng chips araw-araw, oras-oras, at sa pamamagitan ng panonood ng mga ad. Maaari ka ring kumita ng higit pa sa pamamagitan ng pagkumpleto ng Mga Gantimpala sa Gawain o pag-rank sa mga leaderboard.
                </div>

            </div>
        </div>
    )
}

export function PHBaaziStore() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Baazi Store" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.   Ano ang Baazi Store?
                </div>
                <div className={style.sub_text3}>
                    Ang Baazi Store ay kung saan mo iri-redeem ang iyong Reward Points para sa mga voucher, alok, at gift cards mula sa mga nangungunang brand - pinapagana ng Advantage Club.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Na-redeem ko na ang isang gantimpala ngunit hindi ko ito natanggap.
                </div>
                <div className={style.sub_text3}>
                    Maaaring tumagal ng hanggang 48 oras ang mga pag-redeem para maproseso. Kung hindi pa ito dumating, ibahagi ang iyong napiling pangalan ng gantimpala at petsa ng pag-redeem sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> at susuriin namin ito agad.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Kailangan ko bang magkaroon ng hiwalay na Advantage Club login?
                </div>
                <div className={style.sub_text3}>
                    Hindi - awtomatiko kang naka-log in sa pamamagitan ng PokerBaazi. Hindi kailangan ng karagdagang hakbang. <br />
                    Para sa mga premium na alok at mga sorpresang drops, tuklasin ang Baazi Select membership.

                </div>


            </div>
        </div>
    )
}
export function PHBaaziSelectMembership() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Baazi Select Membership" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. Ano ang Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Ang Baazi Select ay ang aming <strong>premium membership subscription</strong> na nagbubukas ng mga advanced na feature sa laro, premium na visual na customization, at eksklusibong access sa Poker TV — kabilang ang mga paparating na season ng <strong>The Circuit</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Ano ang kasama sa Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Binibigyan ka ng Baazi Select ng access sa:
                    <ul className='m-0 ps-3 pt-2'>
                        <li>Mga premium avatar at table theme</li>
                        <li>Mga gameplay tool tulad ng Rabbit at Player Stats</li>
                        <li>Pinahusay na mga table setup</li>
                        <li>Buong access sa Poker TV</li>
                        <li>Eksklusibo at mas malawak na mga alok sa Rewards Store</li>
                        <li>Maagang access sa mga paparating na premium na karanasan</li>
                    </ul>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Nagbibigay ba ng kalamangan sa gameplay ang Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Hindi. Ang Baazi Select ay dinisenyo upang <strong>mapahusay ang iyong karanasan at mga opsyon sa customization</strong>. Hindi ito lumilikha ng hindi patas na kalamangan sa gameplay o nagbabago ng mga resulta ng laro.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Paano ko makukuha ang Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Maaari kang mag-subscribe sa Baazi Select mula sa:
                    <ul className='m-0 ps-3 pt-2'>
                        <li><strong>Seksyong Membership sa Home screen</strong></li>
                        <li><strong>Profile → Membership / Settings</strong></li>
                    </ul>
                    Ang subscription ay ligtas na bini-bill sa pamamagitan ng <strong>Google Play Store / App Store</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Awtomatikong nag-re-renew ba ang Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Oo. Awtomatikong nag-re-renew ang Baazi Select sa pamamagitan ng iyong <strong>Google Play / App Store account</strong> sa katapusan ng bawat billing cycle maliban kung kanselahin bago mag-renew.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Paano ko kakanselahin ang aking membership?
                </div>
                <div className={style.sub_text3}>
                    Maaari kang mag-cancel anumang oras mula sa iyong device subscription settings.<br />
                    <strong>Android:</strong> Google Play → Profile → Payments &amp; subscriptions → Subscriptions → Baazi Select → Cancel<br />
                    <strong>iPhone:</strong> Settings → Apple ID → Subscriptions → Baazi Select → Cancel
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Ano ang mangyayari pagkatapos kong mag-cancel?
                </div>
                <div className={style.sub_text3}>
                    Ang iyong mga benepisyo sa membership ay mananatiling aktibo hanggang sa <strong>katapusan ng iyong kasalukuyang billing period</strong>. Pagkatapos noon, hindi na mag-re-renew ang subscription at mag-e-expire ang mga premium na benepisyo.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Kakanselahin ba ng pag-uninstall ng app ang aking membership?
                </div>
                <div className={style.sub_text3}>
                    Hindi. Ang pag-uninstall ng app ay hindi nagkakansela ng iyong subscription. Upang ihinto ang mga susunod na pag-renew, kailangan mong mag-cancel mula sa iyong <strong>Google Play / App Store subscription settings</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Paano gumagana ang Baazi Select kasama ang Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Binubuksan ng Baazi Select ang isang <strong>premium suite ng mga eksklusibong alok at gift cards mula sa mga nangungunang brand</strong> sa Rewards Store. Nang wala ang membership, limitadong seleksyon lamang ng mga gantimpala ang available.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Maaari ba akong humingi ng refund?
                </div>
                <div className={style.sub_text3}>
                    Ang mga refund para sa mga subscription na binili sa pamamagitan ng <strong>Google Play Store / App Store</strong> ay dapat na hingin nang direkta sa kani-kanilang store. Ang pag-apruba ng refund ay nakasalalay sa kanilang patakaran sa billing.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Ano pa ang maaari kong asahan?
                </div>
                <div className={style.sub_text3}>
                    Patuloy na magbabago ang Baazi Select na may:
                    <ul className='m-0 ps-3 pt-2'>
                        <li>Mga sorpresang pakete sa Baazi Store</li>
                        <li>Mga bagong premium na tool at gameplay utility</li>
                        <li>Mga sariwang tema at table customization</li>
                        <li>Eksklusibong Poker TV content</li>
                        <li>Mga paparating na season ng The Circuit</li>
                    </ul>
                </div>

            </div>
        </div>
    )
}

export function PHTaskRewards() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Mga Gantimpala sa Gawain" />
            <div className="main-container mb-5 px-3"><div className={style.sub_text2_q}> Q. Ano ang Mga Gantimpala sa Gawain?  </div>
                <div className={style.sub_text3}>
                    <p>Ang Mga Gantimpala sa Gawain ay mga araw-araw at lingguhang hamon na nagbibigay sa iyo ng mga chip o Reward Points kapag nakumpleto. Tinutulungan ka nitong mag-progress nang mas mabilis at manatiling engaged sa mga bagong layunin bawat araw. </p>
                </div>
                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>Q. Hindi ko natanggap ang aking gantimpala sa gawain.  </div>
                <div className={style.sub_text3}>
                    <p>Ibahagi ang pangalan ng iyong gawain at oras ng pagkumpleto sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> - tiyakin naming mai-credit ito sa lalong madaling panahon. </p>
                </div>


            </div>
        </div>
    )
}

export function PHTechnicalQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Mga Teknikal na Tanong" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. Hindi nag-lo-load ang app o nagpapakita ng network error.
                </div>
                <div className={style.sub_text3}>
                    Subukang isara at muling buksan ang app at tiyaking matatag ang iyong koneksyon sa internet. Kung nagpapatuloy ang isyu, magpadala sa amin ng screenshot at iyong bersyon ng app sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Naputol ang aking koneksyon sa kalagitnaan ng laro.
                </div>
                <div className={style.sub_text3}>
                    Maaari kang sumali muli sa parehong mesa agad kung aktibo pa ang laro. Ang iyong pag-unlad at mga puntos ay ligtas.                </div>

            </div>
        </div>
    )
}

export function PHWallet() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Wallet" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  Ano ang Chips?
                </div>
                <div className={style.sub_text3}>
                    Ang Chips ay ang iyong in-game na pera na ginagamit sa paglalaro ng mga laro ng poker at torneo. Maaari kang mag-claim araw-araw at oras-oras (bawat 60 minuto) at maaari ring makuha sa pamamagitan ng panonood ng mga ad o pagkumpleto ng mga gawain.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Wala na akong Chips. Ano ang dapat kong gawin?
                </div>
                <div className={style.sub_text3}>
                    Maaari kang mag-claim araw-araw at oras-oras (bawat 60 minuto). Maaari ka ring kumita ng higit pa sa pamamagitan ng panonood ng mga ad o pagkumpleto ng mga gantimpala sa gawain.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Ano ang Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Ang Reward Points ay nakukuha sa pamamagitan ng gameplay - sa pamamagitan ng pag-rank sa mga leaderboard, pagtatapos sa mga bayad na posisyon ng torneo, o pagkumpleto ng mga gawain. Maaaring i-redeem ang mga ito sa Baazi Store para sa mga alok at gift cards mula sa mga nangungunang brand.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Paano ako kumikita ng Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Maglaro ng mga laro, umakyat ng mga leaderboard, kumpletuhin ang mga araw-araw na gawain, o tapusin ang mga posisyon ng kabayaran sa torneo upang kumita ng Reward Points.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Paano ko magagamit ang Reward Points?
                </div>
                <div className={style.sub_text3}>
                    Buksan ang Baazi Store sa app, piliin ang iyong nais na alok o voucher, at i-redeem gamit ang iyong available na Reward Points.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Maaaring i-redeem ang Reward Points para sa pera?
                </div>
                <div className={style.sub_text3}>
                    Hindi. Ang Reward Points ay maaari lamang gamitin upang i-redeem ang mga alok o voucher sa Baazi Store.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Na-redeem ko na ang aking Reward Points ngunit hindi ko natanggap ang item.
                </div>
                <div className={style.sub_text3}>
                    Mangyaring maghintay ng hanggang 48 oras para sa pagproseso. Kung hindi natanggap, makipag-ugnayan sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> kasama ang iyong napiling pangalan ng gantimpala at petsa ng pag-redeem para sa tulong.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Maaari ko bang ilipat ang Chips o Reward Points sa ibang manlalaro?
                </div>
                <div className={style.sub_text3}>
                    Hindi. Ang parehong Chips at Reward Points ay hindi maaaring ilipat at nakakonekta lamang sa iyong account.                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Saan ko maaaring suriin ang aking mga balanse?
                </div>
                <div className={style.sub_text3}>
                    Maaari mong tingnan ang iyong Chips at Reward Points sa seksyong Wallet ng app anumang oras.                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Hindi na-update ang aking balanse. Ano ang dapat kong gawin?
                </div>
                <div className={style.sub_text3}>
                    I-refresh ang app o mag-log out at mag-log in muli. Kung nagpapatuloy ang isyu, makipag-ugnayan sa amin sa <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> kasama ang iyong username at mga detalye ng gameplay.               </div>
            </div>
        </div>
    )
}


